// @flow
import * as types from '../types/time';
import type {
  TIME_UPDATED_TYPE,
} from '../types/time';

export const updateTime = (timestamp: number): TIME_UPDATED_TYPE => ({
  type: types.TIME_UPDATED,
  payload: { timestamp },
});



// WEBPACK FOOTER //
// ./src/scripts/actions/time.js